import { useQuery } from '@apollo/react-hooks';
import { GET_MANDATARIES } from '../../graphql/user/query';
import {
  Mandataries,
  MandatariesVariables,
} from '../../graphql/user/types/Mandataries';

export const useGetMandataries = () => {
  return useQuery<Mandataries, MandatariesVariables>(GET_MANDATARIES, {
    fetchPolicy: 'network-only',
  });
};
